import { render, staticRenderFns } from "./earlyYears.vue?vue&type=template&id=f2fb0582&"
import script from "./earlyYears.vue?vue&type=script&lang=js&"
export * from "./earlyYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports